import { isDefinedArray } from "et3-type-guards";
import { Chart, registerables } from "chart.js";
import { Line } from "react-chartjs-2";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import { TDataREcatJSChart } from "../../Types";
import Empty from "../et3-shared-components/Empty";
import { colors } from "../et3-theme/colors";
import ET3Div from "../et3-div";
import Et3Text from "../et3-text";
import Et3Margin from "../et3-ui/ET3Margin";

const Et3LineChart = withLiteObserverAndTheme<TDataREcatJSChart>((props) => {
  Chart.register(...registerables);
  const {
    chartTitle,
    chartLabel,
    chartYAxis,
    chartXAxis,
    chartColors,
    showEmpty
  } = props;
  const Data = {
    labels: chartXAxis,
    datasets: chartYAxis.map((arrayelements, index) => {
      return {
        label: chartLabel[index],
        data: arrayelements,
        borderWidth: 2,
        fill: false,
        borderColor: chartColors[index],
        tension: 0.1
      };
    })
  };

  return isDefinedArray(chartXAxis) ? (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="center"
      withShadow={false}
      width={1500}
      height={500}
      color={colors.all.white}
      style={{}}
      onClick={() => {}}
    >
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={40}
        text={chartTitle}
        isSpan={false}
        color={colors.all.maastrichtBlue}
        style={{}}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Line
        data={Data}
        options={{
          responsive: true
        }}
      />
    </ET3Div>
  ) : showEmpty ? (
    <Empty />
  ) : null;
});
export default Et3LineChart;
